import React, { useContext } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalRevistas = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const defaultValues = {
        new_conarbitraje: '',
        new_name: '',
        new_autores: '',
        new_revista: '',
        new_fechadepublicacin: '',
        new_volumen: '',
        new_paginas: '',
        new_sitiowebconinformacin: '',
        new_palabrasclave: '',
    }

    const validacionSchema = yup.object().shape({
        new_conarbitraje: yup.boolean().required("Required"),
        new_name: yup.string().required("Required"),
        new_autores: yup.string().required("Required"),
        new_revista: yup.string().required("Required"),
        new_fechadepublicacin: yup.string().required("Required"),
        new_volumen: yup.string().required("Required"),
        new_paginas: yup.number().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    const opcionArbitraje = [
        { value: true, label: 'Si' },
        { value: false, label: 'No' }
    ]

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear publicación en revista</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_conarbitraje"
                                label="Con arbitraje?"
                                helperText="Por favor seleccione un valor"
                                options={opcionArbitraje}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_name"
                                label="Título"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el título."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_autores"
                                label="Autores"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el/los autores."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_revista"
                                label="Revista"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la revista."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechadepublicacin"
                                label="Fecha de publicación:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de publicación"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_volumen"
                                label="Volumen"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el volumen."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_paginas"
                                label="Páginas"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica las páginas."
                                className="custom-helper"
                                type='number'
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_sitiowebconinformacin"
                                label="Sitio web con información"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el sitio web."
                                className="custom-helper"
                        
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_palabrasclave"
                                label="Palabras clave"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica las palabras clave."
                                className="custom-helper"
                               
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalRevistas